import { AubadeComponent } from "js/front/bootstrap";
import { gsap } from 'gsap';
import { customization } from 'storage';

import {
    AubadeViewer,
    OrbitControlsPlugin,
    PinsPlugin,
    RotatePlugin,
    MovePlugin,
    DependencyPin,
    ScenePlugin,
    DynamicEnvironmentMapPlugin,
    LightProbePlugin
} from 'webgl';
import { APP_URL } from 'js/common/AppUrl';

export class SceneRead extends AubadeComponent{
	constructor(e, b){
		super(e, b);

        this.data = JSON.parse(this.element.dataset.data);

        this.loader         = this.element.querySelector(".fps-loader");
        this.viewContainer  = this.element.querySelector(".fps-view-container");
        this.viewPos        = this.element.querySelector(".fps-view-position svg");
        this.banner         = this.element.querySelector(".fps-banner");
        this.estimation     = this.element.querySelector(".fps-estimation");
        this.amount         = this.element.querySelector(".fps-estimation-amount");

        this._viewAngle = 0;

        this.viewer = new AubadeViewer({
            plugins:[
                RotatePlugin,
                MovePlugin,
                // DynamicEnvironmentMapPlugin,
                // LightProbePlugin,
                // DebugPlugin
            ]
        });

        this.viewContainer.appendChild(this.viewer.domElement);
        this.viewer.domElement.style.opacity = 0;
	}

    attach() {
        this.viewport.on('resize', this.onResize);
        this.viewer.attach();
        this.viewer.rendering.ticker.on('tick', this.tick);

        this.viewer.gltfLoader.on('progress', this.onProgress);

    }

    detach() {
        this.viewport.off('resize', this.onResize);
        this.viewer.detach();
        this.viewer.rendering.ticker.off('tick', this.tick);
        this.viewer.gltfLoader.off('progress', this.onProgress);
    }

    onResize = () => {
        this.element.style.height = this.viewport.height + 'px';
    }

    tick = () => {
        this.updateViewAngle();
    }

    updateViewAngle(){
        this.viewAngle = -this.viewer.plugins.get(RotatePlugin).euler.y * 180/Math.PI;
    }

    onProgress = (p) => {
        this.loader.style.setProperty('--fps-loader-progress', `${(p*100).toFixed(2)}%`);
        if(this.progressTm)
            this.progressTm.kill();

        if(p == 1){
            this.progressTm = gsap.to(this.loader, {opacity:0, duration:0.2, delay:0.5, onComplete:() => {
                this.loader.style.setProperty('--fps-loader-progress', '0%');
                this.loader.style.display = "none";
            }});
        }
        else{
            this.loader.style.display = "block";
            this.progressTm = gsap.to(this.loader, {opacity:1, duration:0.2});
        }
    }

    showUI(){
        const t = gsap.timeline();
        t.fromTo(this.viewPos, {scale: 0.5, }, {scale: 1, duration: 1, ease:'expo.out'}, 0.4);
        t.fromTo(this.viewPos, {opacity: 0}, {opacity:1, duration: 0.5}, 0.4);
        t.fromTo(this.banner, {y: this.banner.offsetHeight}, {y: 0, duration: 1, ease:'expo.out'}, 0.3);
        return t;
    }

    hideUI(){
        const t = gsap.timeline();
        t.to(this.viewPos, {opacity: 0, duration: 0.5}, 0);
        t.to(this.banner, {y: this.banner.offsetHeight, duration: 0.5, ease:'expo.in'}, 0);
        return t;
    }

    open(){
        customization.setScene(this.data.scene)
        .then(() => {
            return customization.load(this.data);
        });

        this.viewer.resize();
        this.viewer.start();

        const scenePlugin = this.viewer.plugins.get(ScenePlugin);

        const anim = (() => {
            const t = gsap.timeline();
            t.fromTo(this.viewer.domElement, {opacity: 0}, {opacity: 1, duration: 0.5}, 0);
            t.add(this.showUI());
            return t;
        })()

        const t = gsap.timeline();

        if(scenePlugin.scene){
            t.add(anim);
        }
        else{
            anim.pause();
            scenePlugin.once('scene-changed', () => {
                anim.play(0);
            })
        }
        return t;
	}
	close(){             
		const t = gsap.timeline();
		return t;
	}

    set viewAngle(angle){
        this._viewAngle = angle;
        gsap.set(this.viewPos, {rotate:this._viewAngle});
    }

    get viewAngle() {
        return this._viewAngle;
    }

    set price(value) {
        this._price = value;
        this.amount.innerText = value
    }
    get price() {
        return this._price;
    }
	
}